import { MARQUEE_WORDS } from "../data/site";

export const Marquee = () => {
    const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
    return (
        <section
            data-testid="marquee"
            className="border-y border-[#dddddd] bg-white overflow-hidden"
        >
            <div className="marquee-track flex gap-16 py-8 whitespace-nowrap will-change-transform">
                {items.map((w, i) => (
                    <span
                        key={i}
                        className="font-serif italic text-3xl md:text-5xl text-[#111111] flex items-center"
                    >
                        {w}
                        <span
                            aria-hidden
                            className="mx-10 text-[#dddddd] not-italic"
                        >
                            ✻
                        </span>
                    </span>
                ))}
            </div>
        </section>
    );
};
